<h3 *ngIf="noBrandTitle && isBeNote">{{noBrandTitle}}</h3>
<h2 class="step-title" *ngIf="title">{{title}}</h2>
<h3 class="step-title" *ngIf="subtext">{{subtext}}</h3>

<div class="buttons" *ngIf="newDesignTop10FormABTest">
  <button *ngFor="let button of buttonList"
    class="form-button" type="button"
    [attr.default] = "button.default ? true: null"
    (touchstart)="onlyClick ? submit(button, $event) : null"
    (click)="submit(button)"
    >
    <span class="button-icon">
      <svg aria-hidden="true">
        <use
          [attr.href]="'/assets/images/top10-icons.svg#' + button.imageName"
          [attr.xlink:href]="'/assets/images/top10-icons.svg#' + button.imageName"
        ></use>
      </svg>
    </span>
    <span class="label-text">{{button.text}}</span>
    <span class="label-info">{{button.info}}</span>
  </button>
</div>

<ul *ngIf="!newDesignTop10FormABTest">
    <li *ngFor="let button of buttonList">
      <div>

        <button *ngIf="onlyClick"
          [ngClass]="['icon-button', 'has-shadow-small', button.className || '']"
          [ngStyle]="{'border' : button.borderStyle, 'box-shadow': button.boxShadow}"
          [attr.default] = "button.default ? true: null"
          (click)="submit(button)"
          >
          <div class="button-content">
            <div class="button-image"><img src='{{ buttonPath + "new-" + button.imageName + fileType }}'></div>
            <div class="label">
              <div>{{button.text}}</div>
              <div class="label-info">{{button.info}}</div>
            </div>
          </div>
        </button>

        <button *ngIf="!onlyClick"
          [ngClass]="['icon-button', 'has-shadow-small', button.className || '']"
          [ngStyle]="{'border' : button.borderStyle, 'box-shadow': button.boxShadow}"
          [attr.default] = "button.default ? true: null"
          (click)="submit(button)"
          (touchstart)="submit(button, $event)"
          >
          <div class="button-content">
            <div class="button-image"><img src='{{ buttonPath + "new-" + button.imageName + fileType }}'></div>
            <div class="label">
              <div>{{button.text}}</div>
              <div class="label-info">{{button.info}}</div>
            </div>
          </div>
        </button>
      </div>
    </li>
</ul>

<div *ngIf="poorCreditScore" class="poor-credit-rating-overlay">
  <div class="overlay">
    <h2 class="step-title-capitalized">{{ under500Title }}</h2>

    <div class="buttons" *ngIf="newDesignTop10FormABTest">
      <button *ngFor="let button of poorCredScoreBtns"
        class="form-button" type="button"
        [attr.default] = "button.default ? true: null"
        (touchstart)="onlyClick ? validateCreditScoreOver500(button.value, $event) : null"
        (click)="validateCreditScoreOver500(button.value)"
        >
        <span class="button-icon">
          <svg aria-hidden="true">
            <use
              [attr.href]="'/assets/images/top10-icons.svg#' + button.imageName"
              [attr.xlink:href]="'/assets/images/top10-icons.svg#' + button.imageName"
            ></use>
          </svg>
        </span>
        <span class="label-text">{{button.text}}</span>
        <span class="label-info">{{button.info}}</span>
      </button>
    </div>

    <ul *ngIf="!newDesignTop10FormABTest">
      <li *ngFor="let button of poorCredScoreBtns">
        <button *ngIf="!onlyClick"
          [ngClass]="['icon-button', 'has-shadow-small', button.className || '']"
          [ngStyle]="{'background': (button.default) ? '#e1e1e1' : '#f0ecec', 'border' : button.borderStyle, 'box-shadow': button.boxShadow}"
          [attr.default] = "button.default ? true: null"
          (click)="validateCreditScoreOver500(button.value)"
          (touchstart)="validateCreditScoreOver500(button.value, $event)"
        >

          <div class="button-content">
            <div class="button-image"><img src='{{ buttonPath + "new-" + button.imageName + fileType }}'></div>
            <div class="label">
              <div>{{button.text}}</div>
              <div class="label-info">{{button.info}}</div>
            </div>
          </div>
        </button>

        <button *ngIf="onlyClick"
          [ngClass]="['icon-button', 'has-shadow-small', button.className || '']"
          [ngStyle]="{'background': (button.default) ? '#e1e1e1' : '#f0ecec', 'border' : button.borderStyle, 'box-shadow': button.boxShadow}"
          [attr.default] = "button.default ? true: null"
          (click)="validateCreditScoreOver500(button.value)"
        >

          <div class="button-content">
            <div class="button-image"><img src='{{ buttonPath + "new-" + button.imageName + fileType }}'></div>
            <div class="label">
              <div>{{button.text}}</div>
              <div class="label-info">{{button.info}}</div>
            </div>
          </div>
        </button>
      </li>
    </ul>  
  </div>
</div>
